module.exports = __webpack_public_path__ + "img/img_brand20.29399c63.jpg";